import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import AlertOctagon from 'components/icons/alertOctagon';

import s from 'components/warning/warning.sss';

export default class Warning extends Component {
	render(props) {
		return (
			<div class={joinClasses(s.wrapper, props.class)}>
				<AlertOctagon class={s.icon} />
				<div class={s.content}>
					{props.children}
				</div>
			</div>
		);
	}
}